export default function not(value: any) {
  return !value;
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    not: typeof not;
  }
}
